import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { User } from 'src/app/services/users/interface/user.interface';

@Injectable({
  providedIn: 'root'
})

export class NonInstallerGuardService implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): Observable<boolean> | boolean {
    let value!: boolean;
    const user: User | null = JSON.parse(localStorage.getItem('user')!) || null;

    if (!!(user!.role_id && user!.role_id !== 5)) {
      return true;
    } else {
      this.router.navigate(['/installations']);
      return false;
    }
  }
}